
import './Admin.scss'; 
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import Login from './Login';
import AdminRequireAuth from './AdminRequireAuth';
import Footer from '../components/Footer';
import RegisterRecruit from './recruit/RegisterRecruit';
import RecruitListManagePre from './recruitemail/RecruitEmailManage';
import AdminStatistics from './statistics/AdminStatistics';
import BoardPostManage from './board/BoardPostManage';
import WorshipManage from './worship/WorshipManage';
import WorshipManageAdmin from './worship/WorshipManageAdmin';
import Backup from './Backup';
import AdminEmail from './email_adv/AdminEmail';
import PushNotificationPage from './appmanage/PushNotificationPage';
import AppVersionPage from './appmanage/AppVersionPage';
import AdminUser from './user/AdminUser';
import AdminInquiryManage from './user/AdminInquiryManage';
import axios from 'axios';
import MainURL from '../MainURL';
import { getAdminToken } from './adminSession';

// 관리자 화면에서 이 서버로 보내는 요청에 관리자 토큰을 붙인다 (관리자 전용 API 서버 인증)
// 모듈 로드 시 한 번만 등록된다.
axios.interceptors.request.use((config) => {
  const token = getAdminToken();
  const url = `${config.baseURL || ''}${config.url || ''}`;
  if (token && url.startsWith(MainURL)) config.headers.set('X-Admin-Token', token);
  return config;
});

export default function AdminMain( props: any) {

  return (
    <div className="AdminContainer">
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/main" element={<AdminRequireAuth><Main/></AdminRequireAuth>}/>
        <Route path="/registerrecruit" element={<AdminRequireAuth><RegisterRecruit/></AdminRequireAuth>}/>
        <Route path="/recruitlistmanagepre" element={<AdminRequireAuth><RecruitListManagePre/></AdminRequireAuth>}/>
        <Route path="/adminmanage" element={<AdminRequireAuth><AdminStatistics /></AdminRequireAuth>}/>
        <Route path="/boardpostmanage" element={<AdminRequireAuth><BoardPostManage /></AdminRequireAuth>} />
        <Route path="/freeboardmanage" element={<AdminRequireAuth><BoardPostManage initialTab="free" /></AdminRequireAuth>} />
        <Route path="/eventsboardmanage" element={<AdminRequireAuth><BoardPostManage initialTab="events" /></AdminRequireAuth>} />
        <Route path="/usedboardmanage" element={<AdminRequireAuth><BoardPostManage initialTab="used" /></AdminRequireAuth>} />
        <Route path="/worshipmanage" element={<AdminRequireAuth><WorshipManage/></AdminRequireAuth>}/> 
        <Route path="/backup" element={<AdminRequireAuth><Backup/></AdminRequireAuth>}/>
        <Route path="/worshipmanageadmin" element={<AdminRequireAuth><WorshipManageAdmin/></AdminRequireAuth>}/>
        <Route path="/emailmanage" element={<AdminRequireAuth><AdminEmail /></AdminRequireAuth>}/>
        <Route path="/pushnotifi" element={<AdminRequireAuth><PushNotificationPage /></AdminRequireAuth>}/>
        <Route path="/appversion" element={<AdminRequireAuth><AppVersionPage /></AdminRequireAuth>}/>
        <Route path="/adminuser" element={<AdminRequireAuth><AdminUser /></AdminRequireAuth>}/>
        <Route path="/admininquiry" element={<AdminRequireAuth><AdminInquiryManage /></AdminRequireAuth>}/>
      </Routes>
      <Footer />
    </div>
  );
}
